import { useAppStateSelector } from '../../providers/AppStateProvider';
import { TEMPORARY_ID } from '../AppLayout/tokens';
import { selectActiveSessionId } from './redux/preTradeSlice';

/**
 * Returns whether the provided session id is the currently active pre-trade session
 * and is being viewed in the temporary panel.
 */
export function useIsActivePreTradeSession({
  sessionId,
  panelId,
}: {
  sessionId: string | undefined;
  panelId: string | undefined;
}): boolean {
  const activeSessionId = useAppStateSelector(selectActiveSessionId);

  if (panelId !== TEMPORARY_ID) {
    return false;
  }

  return sessionId != null && sessionId === activeSessionId;
}
